import { TriggerConfigSchema } from "@redotech/redo-shopper-agent-common/trigger-config";
import { ShopperAgentChannelsConfigSchema } from "@redotech/redo-shopper-agent-settings-common/channel-config";
import { ShopperAgentHumanQueueConfigSchema } from "@redotech/redo-shopper-agent-settings-common/human-queue-config";
import { ShopperAgentReplyConfigSchema } from "@redotech/redo-shopper-agent-settings-common/reply-config";
import * as z from "zod";

/** What is live, for surfaces that report on the agent rather than edit it. */
export const PublishedShopperAgentSettingsSchema = z.object({
  enabled: z.boolean(),
  channels: ShopperAgentChannelsConfigSchema.optional(),
  replyConfig: ShopperAgentReplyConfigSchema.optional(),
  recoverConfig: ShopperAgentHumanQueueConfigSchema.optional(),
  triggers: z.record(z.string(), TriggerConfigSchema).optional(),
});

export const getPublishedShopperAgentSettings = {
  name: "getPublishedShopperAgentSettings" as const,
  input: z.object({}),
  output: z.object({
    /** Null when nothing is published, or the team still reads from Mongo. */
    settings: PublishedShopperAgentSettingsSchema.nullable(),
  }),
};
